import React from 'react';
import { graphql } from 'react-relay';

import QueryLookupRenderer from 'relay-query-lookup-renderer';

import useRelay from '@zego/hooks/useRelay';

import ScooterQuickEstimatesForm from '../forms/ScooterQuickEstimatesForm';

export default function StandaloneScooterQuickEstimates(props) {
  const { environment } = useRelay();

  return (
    <QueryLookupRenderer
      lookup
      query={graphql`
        query StandaloneScooterQuickEstimatesQuery {
          viewer {
            ...ScooterQuickEstimatesForm_viewer
          }
        }
      `}
      environment={environment}
      variables={{}}
      render={({ props: renderProps }) => {
        if (renderProps) {
          return <ScooterQuickEstimatesForm {...props} {...renderProps} />;
        }
        return null;
      }}
    />
  );
}
